import { render, staticRenderFns } from "./newsIndustry.vue?vue&type=template&id=873bd3b0&scoped=true&"
import script from "./newsIndustry.vue?vue&type=script&lang=js&"
export * from "./newsIndustry.vue?vue&type=script&lang=js&"
import style0 from "./newsIndustry.vue?vue&type=style&index=0&id=873bd3b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873bd3b0",
  null
  
)

export default component.exports